import { Center, Box, Spinner } from '@chakra-ui/react';
import { useEffect, useState, type PropsWithChildren } from 'react';
import { Empty } from '../Empty';

const Loading = (props: PropsWithChildren<{ spin: boolean; display: boolean }>) => {
  const { spin, display, children } = props;
  const [showLoading, setShowLoading] = useState(false);
  useEffect(() => {
    if (spin) {
      const timer = setTimeout(() => {
        setShowLoading(true);
      }, 1000);

      return () => {
        clearTimeout(timer);
        setShowLoading(false);
      };
    } else {
      setShowLoading(false);
    }
  }, [spin]);

  return (
    <Box pos="relative" w="full" h="full">
      {display ? children : <Empty className="fadeIn" />}
      {showLoading && (
        <Box pos="absolute" inset="0" bg="bg/80" className="fadeIn">
          <Center h="full">
            <Spinner color="brand" />
          </Center>
        </Box>
      )}
    </Box>
  );
};
export { Loading };
